module.exports = __webpack_public_path__ + "img/top3-1.c3fbd6e8.png";